<template>
    <div class="bg-white p-4 shadow-sm h-max">
            <div class="w-full flex gap-4 items-center">
                <img :src="detail?.product?.thumbnail" class="w-[12.5rem] h-full rounded" alt="">
                <div class="w-full">
                    <div class="flex justify-between items-center mb-2">
                        <p class="font-bold text-main-color text-xl">{{ detail?.product?.name }}</p>
                        <button @click="deleteCartItem(0)" class="bg-[#EB5757] p-2 flex items-center justify-center rounded">
                            <IconTrash></IconTrash>
                        </button>
                    </div>
    
                    <div class="flex justify-between items-center">
                        <p v-if="!detail?.product?.discount && !detail?.product?.discount_percent" class="text-[#409DBA] font-bold text-lg">{{ formatNumber(detail?.product?.price) }} TMT</p>
                        <p class="text-[#409DBA] font-bold text-lg leading-4" v-if="detail?.product?.discount_percent">
                        {{ formatNumber(detail?.product?.price - (detail?.product?.price * (detail?.product?.discount_percent / 100))) }} TMT <br><span class="line-through font-semibold text-base text-[#CB3131]">{{ formatNumber(detail?.product?.price) }} TMT</span></p>
    
                        <div class="flex gap-1 font-bold">
                            <button class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded" @click="updateCartItem(detail?.quantity - 1)">-</button>
                            <span class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded">{{ detail?.quantity }}</span>
                            <button class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"  @click="updateCartItem(detail?.quantity + 1)">+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
    
<script>
import IconTrash from '@icons/IconTrash.vue'
import { formatNumber } from '@/helpers'

export default {
    name: 'FoodCartCard',
    components: {
        IconTrash
    },
    props: {
        detail: {
            type: Object,
            default: {}
        },
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {
        formatNumber,
        deleteCartItem(qty) {
            this.$store.deleteFoodCartItem(this.detail?.id, qty).then((e) => {
                this.loading = false
            })
        },
        updateCartItem(qty) {
            this.loading = true
            if (qty === 0) {
                this.deleteCartItem(this.detail?.id, qty)
                return
            }
            this.$store.updateFoodCartItem(this.detail?.id, qty).then((e) => {
                this.loading = false
            })

        },
    },
    computed: {

    },
    created(){

    }
}
    
</script>